import "../../styles/blocks/apps/apps-banner.scss";

import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage as Image } from "gatsby-plugin-image";
import Reveal from "../../components/Animations/Reveal";
import PageHeader from "../../components/PageHeader";

const AppsBanner = ({ title, subtitle, icons, pageHeader }) => {
	return (
		<section className="apps-banner">
			<div className="container">
				<PageHeader
					{...pageHeader}
					title={pageHeader?.title || title}
					implemented={true}
					className={"section-title section-title--large apps-banner__title"}
					isGeneral={true}
				/>

				{icons && icons.length > 0 &&
					<Reveal
						className="apps-banner__icons"
					>
						{icons.map(({ icon }, index) => {
							const image = icon.localFile?.childImageSharp?.gatsbyImageData;
							const altText = icon.altText || "";

							if (!image) {
								return null;
							}

							return (
								<div
									key={index}
									className="apps-banner__icons-item"
								>
									<Image
										className="apps-banner__icons-image"
										image={image}
										alt={altText || title}
										title={altText || title}
									/>
								</div>
							);
						})}
					</Reveal>
				}

				{subtitle && (
					<Reveal as="p"
						className="section-subtitle apps-banner__subtitle"
					>
						{subtitle}
					</Reveal>
				)}
			</div>
		</section>
	);
};

AppsBanner.props = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	icons: PropTypes.array
};

export default AppsBanner;
